module.exports = __webpack_public_path__ + "static/media/wallet_onboarding_03.aeeee602.svg";